import { render, staticRenderFns } from "./UtilsSidebar.vue?vue&type=template&id=28af84b9"
import script from "./UtilsSidebar.vue?vue&type=script&lang=js"
export * from "./UtilsSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports